import React from 'react';

export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.4 8.54V11.06C10.4 13.16 9.56 14 7.46 14H4.94C2.84 14 2 13.16 2 11.06V8.54C2 6.44 2.84 5.6 4.94 5.6H7.46C9.56 5.6 10.4 6.44 10.4 8.54Z"
        fill="#0376C9"
      />
      <path
        d="M11.06 2H8.54C6.69015 2 5.82259 2.65645 5.64184 4.24341C5.60403 4.57541 5.87899 4.85 6.21314 4.85H7.46C9.98 4.85 11.15 6.02 11.15 8.54V9.78686C11.15 10.121 11.4246 10.396 11.7566 10.3582C13.3435 10.1774 14 9.30985 14 7.46V4.94C14 2.84 13.16 2 11.06 2Z"
        fill="#0376C9"
      />
    </svg>
  );
};
